import FetchApi from '../httpUtil/FetchApi';
import api from '../httpUtil/ServerApi';

export let login = new FetchApi({
  requestType: 'LOGIN',
  url: api.LOGIN
});

export let GetPurchaseOrder = new FetchApi({
  requestType: 'GetPurchaseOrder',
  url: api.GetPurchaseOrder
});

export let Getstates = new FetchApi({
  requestType: 'Getstates',
  url: api.Getstates
});

export let Export = new FetchApi({
  requestType: 'Export',
  url: api.Export
});

export let GetPurchaseOrderDetail = new FetchApi({
  requestType: 'GetPurchaseOrderDetail',
  url: api.GetPurchaseOrderDetail
});

export let UpdatePurchaseOrderDetail = new FetchApi({
  requestType: 'UpdatePurchaseOrderDetail',
  url: api.UpdatePurchaseOrderDetail
});

export let POStatusReport = new FetchApi({
  requestType: 'POStatusReport',
  url: api.POStatusReport
});

export let PrintPO = new FetchApi({
  requestType: 'PrintPO',
  url: api.PrintPO
});

export let GetClaims = new FetchApi({
  requestType: 'GetClaims',
  url: api.GetClaims
});

export let GetClaimDetail = new FetchApi({
  requestType: 'GetClaimDetail',
  url: api.GetClaimDetail
});

export let ClaimExport = new FetchApi({
  requestType: 'ClaimExport',
  url: api.ClaimExport
});

export let PrintClaim = new FetchApi({
  requestType: 'PrintClaim',
  url: api.PrintClaim
});

export let ClaimStatusReport = new FetchApi({
  requestType: 'ClaimStatusReport',
  url: api.ClaimStatusReport
});